module.exports = __webpack_public_path__ + "img/p1-c3-p4.68ed8538.jpg";